(ns ballot-scout-v2-frontend.request-helpers
  (:require
   [re-frame.core :as rf]))

(rf/reg-event-db
 ::request-failed
 (fn [db [_ request-event-vec response]]
   (assoc-in db [::failed-requests request-event-vec] response)))

(rf/reg-event-db
 ::clear-failed-request
 (fn [db [_ request-event-kw]]
   (update db ::failed-requests #(dissoc % request-event-kw))))

(rf/reg-sub
 ::failed-request
 (fn [db [_ request-event-vec]]
   (get-in db [::failed-requests request-event-vec])))
